import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import useRouter from 'hooks/useRouter'
import { useRef } from 'react'

export default function ResourceExpiredModal({
  open,
  toggleModalState,
  packageExpire,
}) {
  const modalRef = useRef(null)
  const { navigate } = useRouter()
  return (
    <DraggableModal
      title="Thuê bao sắp hết hạn"
      applyText="Gia hạn ngay"
      ref={modalRef}
      isOpen={open}
      onOpenChange={(state) => toggleModalState(state)}
      handleApplyChanges={() => {
        navigate('/hoa-don-dau-ra/he-thong/tai-nguyen')
        toggleModalState(false)
      }}
    >
      <div className="pop-body">
        Thuê bao của Quý khách sẽ hết hạn tài nguyên truyền nhận hóa đơn điện tử{' '}
        <span style={{ color: '#EE2334D9' }}>
          sau {packageExpire?.daysLeft} ngày nữa{' '}
        </span>
        . Vui lòng gia hạn thêm tài nguyên để tránh gián đoạn{' '}
      </div>
    </DraggableModal>
  )
}
